export default "__VITE_ASSET__MZjuBC4w__"